"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Icon = require("../../Icon");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    title: {
      fontSize: 20
    },
    icon: {
      fontSize: 20,
      margin: spacing(3)
    },
    logo: {
      height: 40,
      width: 40,
      objectFit: 'contain',
      marginRight: spacing(3)
    }
  };
});

var MerchantHeader = function MerchantHeader(_ref2) {
  var title = _ref2.title,
      logo = _ref2.logo,
      onBack = _ref2.onBack;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: classes.icon,
    icon: "arrow-left",
    color: "inherit",
    onClick: onBack
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.logo,
    src: logo,
    alt: "Merchant logo"
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    className: title
  }, title));
};

var _default = /*#__PURE__*/(0, _react.memo)(MerchantHeader);

exports["default"] = _default;